import { fs } from './config/firebaseInit';
import { saveAs } from 'file-saver';
export default function downloadUrl(url) {
  fs.refFromURL(url).getMetadata().then((data) => {
    saveAs(url, data.name);
  }).catch((error) => {
    console.log('could not download song: ', error);
  });
}